/** Shopify CDN: Minification failed

Line 85:0 Transforming class syntax to the configured target environment ("es5") is not supported yet
Line 86:13 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 92:21 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 93:4 Transforming let to the configured target environment ("es5") is not supported yet
Line 105:13 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 112:9 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 113:4 Transforming const to the configured target environment ("es5") is not supported yet
Line 117:14 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 118:4 Transforming const to the configured target environment ("es5") is not supported yet
Line 124:12 Transforming object literal extensions to the configured target environment ("es5") is not supported yet

**/
/** Shopify CDN: Minification failed

Line 71:0 Transforming class syntax to the configured target environment ("es5") is not supported yet
Line 72:13 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 78:21 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 79:4 Transforming let to the configured target environment ("es5") is not supported yet
Line 91:13 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 98:9 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 99:4 Transforming const to the configured target environment ("es5") is not supported yet
Line 103:14 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 104:4 Transforming const to the configured target environment ("es5") is not supported yet
Line 110:12 Transforming object literal extensions to the configured target environment ("es5") is not supported yet

**/
/** Shopify CDN: Minification failed

Line 57:0 Transforming class syntax to the configured target environment ("es5") is not supported yet
Line 58:13 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 64:21 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 65:4 Transforming let to the configured target environment ("es5") is not supported yet
Line 77:13 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 84:9 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 85:4 Transforming const to the configured target environment ("es5") is not supported yet
Line 89:14 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 90:4 Transforming const to the configured target environment ("es5") is not supported yet
Line 96:12 Transforming object literal extensions to the configured target environment ("es5") is not supported yet

**/
/** Shopify CDN: Minification failed

Line 43:0 Transforming class syntax to the configured target environment ("es5") is not supported yet
Line 44:13 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 50:21 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 51:4 Transforming let to the configured target environment ("es5") is not supported yet
Line 63:13 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 70:9 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 71:4 Transforming const to the configured target environment ("es5") is not supported yet
Line 75:14 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 76:4 Transforming const to the configured target environment ("es5") is not supported yet
Line 82:12 Transforming object literal extensions to the configured target environment ("es5") is not supported yet

**/
/** Shopify CDN: Minification failed

Line 29:0 Transforming class syntax to the configured target environment ("es5") is not supported yet
Line 30:13 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 36:21 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 37:4 Transforming let to the configured target environment ("es5") is not supported yet
Line 49:13 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 56:9 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 57:4 Transforming const to the configured target environment ("es5") is not supported yet
Line 61:14 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 62:4 Transforming const to the configured target environment ("es5") is not supported yet
Line 68:12 Transforming object literal extensions to the configured target environment ("es5") is not supported yet

**/
/** Shopify CDN: Minification failed

Line 15:0 Transforming class syntax to the configured target environment ("es5") is not supported yet
Line 16:13 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 22:21 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 23:4 Transforming let to the configured target environment ("es5") is not supported yet
Line 35:13 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 42:9 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 43:4 Transforming const to the configured target environment ("es5") is not supported yet
Line 47:14 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 48:4 Transforming const to the configured target environment ("es5") is not supported yet
Line 54:12 Transforming object literal extensions to the configured target environment ("es5") is not supported yet

**/
class MainSearch extends SearchForm {
  constructor() {
    super();
    this.allSearchInputs = document.querySelectorAll('input[type="search"]');
    this.setupEventListeners();
  }

  setupEventListeners() {
    let allSearchForms = [];
    this.allSearchInputs.forEach(input => allSearchForms.push(input.form))
    this.input.addEventListener('focus', this.onInputFocus.bind(this));
    if (allSearchForms.length < 2) return;
    allSearchForms.forEach(form =>
      form.addEventListener('reset', this.onFormReset.bind(this))
    );
    this.allSearchInputs.forEach(input =>
      input.addEventListener('input', this.onInput.bind(this))
    );
  }

  onFormReset(event) {
    super.onFormReset(event);
    if (super.shouldResetForm()) {
      this.keepInSync('', this.input);
    }
  }

  onInput(event) {
    const target = event.target;
    this.keepInSync(target.value, target);
  }

  onInputFocus() {
    const isSmallScreen = window.innerWidth < 750;
    if (isSmallScreen) {
      this.scrollIntoView({behavior: 'smooth'});
    }
  }

  keepInSync(value, target) {
    this.allSearchInputs.forEach(input => {
      if (input !== target) {
        input.value = value;
      }
    });
  }
}

customElements.define('main-search', MainSearch);
